export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Final (2)_00.62dd7e7d.jpg";